@import '~style-sheet-helpers/core.less';

.save-filterset-modal {
  width: 540px;
}

.modal-body {
  padding: 15px;
  overflow: auto;
  flex: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.modal-footer {
  > button {
    margin-left: 10px;
  }
}
